import { getGridPos, BLOCK_SIZE , GROUND_COLOR} from './utils'
import Tile from './Tile'
import Bar from './Bar'

class Tower extends Tile {
  constructor(type, gridSpot) {
    super(gridSpot)
    this.type = 'TOWER'

    const pos = getGridPos(gridSpot)
    this.x = pos.x
    this.y = pos.y
    this.defaultShootTimer = 50
    this.shootDelay = 0
    this.range = 1
    this.damage = 5

    this.loadingBar = new Bar(this, '#00ff00', {x: 10, y: 35})

    const image = document.getElementById('tower')
    this.img = image

    this.animationStep = 0
    this.time = 0

    this.flipped = true
  }

  draw(c) {
    c.beginPath()
    c.strokeStyle = '#cdcdcd'
    c.rect(this.x, this.y, BLOCK_SIZE, BLOCK_SIZE)
    c.fillStyle = GROUND_COLOR
    c.fill()
    c.stroke()
    c.closePath()

    if(this.img) {
      // Bad for performance, duplicate the sprite sheet and flip it!
      if(this.flipped) {
        c.save()
        c.scale(-1, 1)
        c.drawImage(this.img, 64*this.animationStep, 0, 64, 64, this.x*-1, this.y, -64, 64)
        c.restore()
      } else {
        c.drawImage(this.img, 64*this.animationStep, 0, 64, 64, this.x, this.y, 64, 64)
      }

      // if(this.time%1 === 0) {
      //   this.animationStep++
      //   if(this.animationStep > 6) {
      //     this.animationStep = 0
      //   }
      // }
    }
  }

  shoot(enemies) {
    const neighborGridSpors = Object.values(this.neighbors)
      .concat(Object.values(this.diagonalNeighbors))
      .map(tile => tile.gridSpot)

    const enemiesInRange = enemies.filter((enemy) => {
      return neighborGridSpors.includes(enemy.gridSpot)
    })

    if(enemiesInRange[0] && this.shootDelay <= 0) {
      enemiesInRange[0].hp -= this.damage

      this.flipped = enemiesInRange[0].x > this.x

      this.shootDelay = this.defaultShootTimer
    }
  }

  update(c) {
    this.time++
    this.draw(c)
    this.loadingBar.update(c, 1-(this.shootDelay/this.defaultShootTimer))
    this.shootDelay = this.shootDelay > 0 ? this.shootDelay-1 : 0
  }
}

export default Tower
